import { render, staticRenderFns } from "./PaypalClientId.vue?vue&type=template&id=73d309cd&"
import script from "./PaypalClientId.vue?vue&type=script&lang=ts&"
export * from "./PaypalClientId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports